import React, { useRef } from 'react';
import axios from 'axios';
import { Modal, Button,Row,Col } from 'react-bootstrap';
import {  Input, Tooltip } from 'reactstrap';
import Select from 'react-select';
import { var_api } from "../constant";
import { useState,useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import Bill from '../Foods/bill';
import Swal from 'sweetalert2';
import {toast} from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './paymodeStatusMaster.css';
import Layout from '../NewHeader/Layout';
import Pagination from 'react-js-pagination';

toast.configure()

const PaymodeStatusMaster = () => {
    const history = useHistory();
    const [ shopPaymodes, setShopPaymodes ] = useState([]);
    const shop_id = localStorage.getItem('shopId');
    const user_id = localStorage.getItem('userId');
    const [tables, setTables] = useState([]);
    const [DeleteId, setEmployeeD] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const shopName = localStorage.getItem('shopName');
    const [switches, setSwitches] = useState([]);
    const [balanceSwitches, setBalanceSwitches] = useState([]);
    const [ searchQuery,setSearchQuery] = useState('');
    const [paymodeName, setPaymodeName] = useState('');
    const [paymodeCode, setPaymodeCode] = useState('');
    const [description, setDescription] = useState('');
    const [transactionFee, setTransactionFee] = useState('');
    // const [filteredPaymodes, setFilteredPaymodes] = useState([]); // For the filtered list of paymodes
    const [tooltipOpen, setTooltipOpen] = useState({}); // Tooltip state
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [EditId, setEditID] = useState('');
    const [payModeBalance, setPaymodeBalance] = useState('');
    const [IsActive, setIsactive] = useState('');

  
    const[showDelete,setShow]=useState(false);
 // Show modal
 const [currentPage, setCurrentPage] = useState(1);
 const [itemsPerPage] = useState(10); // Number of items per page
 const [searchTerm, setSearchTerm] = useState('');
 
 // Filtering tables based on search term
 const filteredTables = tables.filter((item) => {
   return (
     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.description.toLowerCase().includes(searchTerm.toLowerCase()) 

   );
 });
 
 // Pagination logic
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
 const totalItems = filteredTables.length;
 
 const handleSearchInput = (event) => {
   setSearchTerm(event.target.value);
   setCurrentPage(1); // Reset to the first page when search changes
 };
 
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };
 // Close modal
 const handleClose = () => setShowModal(false);
 const handleCloseEdit = () => setShowModalEdit(false);


      //go to home page
  const handleButtonClickhome = () => {
    // Navigate to a specific route using history.push
    history.push('/home');
  };


  const handlePaymodeSubmit = (e) => {
    e.preventDefault();
    const shopId=localStorage.getItem('ShopId');
    // Prepare the payload
    const payload = {
      shop_id: shopId, // Replace with the appropriate shop_id value
      name: paymodeName,
      description: description,
      is_active: 1, // Default value for active status
      balance_status: 1, // Replace with the appropriate value
      created_at: new Date().toISOString(), // Current timestamp
      updated_at: new Date().toISOString(), // Current timestamp
    };
  
    const token = localStorage.getItem('Token');
  
    axios
      .post(`${var_api}paymode-master/post`, payload, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
          Swal.fire("Success", "Paymode created successfully!", "success");
          handleReset(); // Reset form fields
          handleClose(); // Close the modal
          fetchTables(); // Refresh the table data
      
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error creating data:", error);
        }
        Swal.fire(
          "Error",
          `${error.response?.data?.error || "Unexpected error occurred"}`,
          "error"
        );
      });
  };
  
    //delete method for remove UOM
    const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };
    // Function to reset the form
    const handleReset = () => {
        setPaymodeName('');
        setPaymodeCode('');
        setDescription('');
        setTransactionFee('');
      };
    
      // Function for navigation or redirection
      const handleButtonClick = () => {
        // Navigation logic to go to home
      };
    
      // Function to handle editing a paymode
      const handleEditPaymode = (paymode) => {
        setPaymodeName(paymode.name);  // Set the name of the paymode in the input
        setDescription(paymode.description);   // Set the description of the paymode in the input
        setShowModalEdit(true); // Show the modal for editing
        setEditID(paymode.id);
        setPaymodeBalance(paymode.balance_status);  // Set the name of the paymode in the input
        setIsactive(paymode.is_active);
      };
      
    
      // Function to handle deleting a paymode
      const handleDeletePaymode = (id, paymodeName) => {
        setShow(true);
        // Delete logic for paymode
      };
      //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}paymode-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "PAYMODE removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error deleting data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
      };


//go to table order page
  const handleToRedirectTableOrder = () => {
    // Navigate to a specific route using history.push
    history.push('/tableOrders');
  };

  useEffect(() => {
    fetchTables();
   
}, []);



const fetchTables = async (id) => {
  const token = localStorage.getItem('Token');
  console.log(id)
  const shopId =localStorage.getItem('ShopId');
  try {
     const shop = localStorage.getItem('ShopId')
     const response = await axios.get(`${var_api}paymode-master/get/${shopId}`,{
      headers:{
        Authorization:`${token}`
      }
     });
     console.log("response",response)
    const user =response.data.data;
    setTables(user);
    
  } catch (error) {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    setTables([])
  }
};


const handleShow = () => 
  {
    setShowModal(true);
    handleReset();
    

  };
const fetchAllShopPaymodes = async () => {
    setIsLoading(true);
    try {
        const response = await axios.get(`${var_api}/api/shop-paymode/getAll-paymode-list/${shop_id}/${user_id}`);
        const shopPaymodeData = response.data;
        if (shopPaymodeData.length > 0) {
            setShopPaymodes(shopPaymodeData);
            setIsLoading(false);
            const initialSwitches = shopPaymodeData.map((location) => location.is_active === 1);
            console.log("initialSwitches",initialSwitches)
            setSwitches(initialSwitches)
            const initialBalanceSwitches = shopPaymodeData.map((location) => location.show_balance === 1);
            console.log("initialBalanceSwitches",initialBalanceSwitches)
            setBalanceSwitches(initialBalanceSwitches)
        } else {
            console.log('No data found.');
            setShopPaymodes([]);
            setIsLoading(false);
        }
    } catch (error) {
        setShopPaymodes([]);
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error fetching data:", error);
        }
    }
};


const handleToggle1 = (isChecked, item) => {
  const payload = {
    shop_id: item.shop_id,
    name: item.name,
    description: item.description,
    balance_status: item.balance_status,
    is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
  };

  const token = localStorage.getItem('Token');
  
  axios
    .put(`${var_api}paymode-master/put/${item.id}`, payload, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (response.status === 200) {
        Swal.fire("Success", "Status updated successfully!", "success");
        fetchTables();
      } else {
        Swal.fire("Error", "Failed to update category status!", "error");
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
    });
};

const handleToggle = (isChecked, item) => {
  const payload = {
    shop_id: item.shop_id,
    name: item.name,
    description: item.description,
    balance_status:isChecked ? 1 : 0,
    is_active:  item.is_active, // Convert boolean to 1 or 0
  };

  const token = localStorage.getItem('Token');
  
  axios
    .put(`${var_api}paymode-master/put/${item.id}`, payload, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (response.status === 200) {
        Swal.fire("Success", "Balance status updated successfully!", "success");
        fetchTables();
      } else {
        Swal.fire("Error", "Failed to update category status!", "error");
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
    });
};



  //toggle switch for is_active updation
const handleBalanceToggle = async (index,id) => {
    const newSwitches = [...balanceSwitches];
    console.log('newSwitches', newSwitches);
    console.log('newSwitches', !newSwitches[index]);
    newSwitches[index] = !newSwitches[index];
    console.log('newSwitches', newSwitches[index]);
   
    setBalanceSwitches(newSwitches);
    console.log('newSwitches', newSwitches);
    

// Make an API request to update the location_status
try {
const response = await axios.put(`${var_api}/api/shop-paymode/put/${id}`, { show_balance: newSwitches[index] ? 1 : 0 });
if (response.status === 200) {
  console.log('status updated successfully');
  fetchAllShopPaymodes();
}
} catch (error) {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('Token'); // Clear the invalid token
    history.push('/')// Redirect to the Sign-In page
  } else {
    console.error("Error updating data:", error);
  }
// Revert the switch state in case of an error
newSwitches[index] = !newSwitches[index];
setBalanceSwitches(newSwitches);
}
  };




    const update = async (e) => {
      e.preventDefault();
      const paymodeData = {
        name: paymodeName,
        description: description,
        is_active: IsActive, // Set active status as needed
        balance_status: payModeBalance, // You can adjust this based on the logic
      };
      try {
        const token = localStorage.getItem("Token"); // Replace with your token logic
        const response = await axios.put(
          `${var_api}paymode-master/put/${EditId}`, // Use the selected item's ID
          paymodeData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (response.status === 200) {
          Swal.fire("success"," PAYMODE Updated Successfully!","success")

          setShowModalEdit(false); // Close the modal
          fetchTables(); // Refresh the data
        }
      } catch (error) {
        Swal.fire("Error", `${error.response.data.message}`, "error");
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
      }
    };

    
    //search the transaction data
    const filteredPaymodes = shopPaymodes.filter((order) => {
        const searchLower = searchQuery.toLowerCase();
        return (
          (order.pay_mode_name && order.pay_mode_name.toString().toLowerCase().includes(searchLower)) ||
          (order.description && order.description.toString().toLowerCase().includes(searchLower))
          
        );
      });




  return(
    <>
    <Layout>
   
        <div style={{ padding: "20px", width: "100%", height: "700px", margin: "auto", borderRadius: "15px", backgroundColor: "white", boxShadow: "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px" }}>

            <div className='d-flex justify-content-between mb-4'>
            <h4 className='ushe'>PAYMODE MASTER</h4>
            <Row>
            {/* <Button  onClick={handleShow} class="btn btn-info">CREATE </Button> */}
            <Col>
            <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/></Col>
              <Col>
                      <Button variant='dark'className='mb-4' onClick={handleShow}   style={{fontSize:"14px",float:"right",borderRadius:"10px"}}>Create Paymode</Button>
                      </Col> </Row>

          </div>
          <div className='d-flex justify-content-end mb-2'>
          
          </div>
            <div className="table-container" style={{ overflowX: 'auto', overflowY: 'scroll' }}>
              <table className="table table-hover small-first-col" style={{ border: 'none', borderColor: 'grey', width: '100%' }}>
                <thead>
                  <tr style={{ fontWeight: 'bolder' }}>
                    <th scope="col">S.No</th>
                    <th scope="col">Paymode Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Show Balance Status</th>
                    <th scope="col">Active Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody className="body-half-screen">
                  {isLoading ? (
                    <tr>
                      <td colSpan={6} style={{ fontWeight: 'bolder', textAlign: 'center', color: 'red' }}>
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : currentItems.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{  textAlign: 'center', color: 'grey' }}>No Data Available</td>
                    </tr>
                  ) : (
                    currentItems
                      .filter(paymode => paymode.name !== "CREDIT ORDER" && paymode.name !== "GROUP LOCATION CREDIT ORDER")
                      .map((paymode, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{paymode.name}</td>
                          <td>{paymode.description}</td>
                          <td>
                            <div className="form-check form-switch">
                            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={paymode.balance_status === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, paymode)}
            />
                            </div>
                          </td>
                          <td>
                            <div className="form-check form-switch">
                            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={paymode.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle1(e.target.checked, paymode)}
            />
                            </div>
                          </td>
                          <td>
                          <i className="bi bi-pencil-square" onClick={() => handleEditPaymode(paymode)} style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}></i>{' '}
                          <i className="bi bi-trash" onClick={() => handleDeleteEmployeee(paymode.id)} style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}></i>
              </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </table>
              <Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
            </div>
            <br />
            <br />
        </div>
        <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>PAYMODE MASTER</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handlePaymodeSubmit}>
            <div >
              <label style={{ fontWeight: "bold", fontSize: "14px" }} className='form-label'>
                Paymode Name
              </label>
              <input
                className="form-control mb-4"
                type='text'
                name='paymode_name'
                placeholder='Enter Paymode Name'
                required
                value={paymodeName}
                onChange={(e) => setPaymodeName(e.target.value)}
              />
            </div>
          
            <div >
              <label style={{ fontWeight: "bold", fontSize: "14px" }} className='form-label'>
                Description
              </label>
            
              <input
                className="form-control mb-4"
                type='text'
                name='paymode_name'
                placeholder='Enter Description'
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          
            <div className="d-flex justify-content-end">
              
              <Button variant="secondary"  onClick={handleReset}>
                Reset
              </Button>
              <Button variant="success" className="ms-2" type="submit">
                Create 
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={showModalEdit} onHide={handleCloseEdit} centered>
        <Modal.Header closeButton>
          <Modal.Title>EDIT PAYMODE MASTER</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={update}>
            <div >
              <label style={{ fontWeight: "bold", fontSize: "14px" }} className='form-label'>
                Paymode Name
              </label>
              <input
                className="form-control mb-4"
                type='text'
                name='paymode_name'
                placeholder='Enter Paymode Name'
                required
                value={paymodeName}
                onChange={(e) => setPaymodeName(e.target.value)}
              />
            </div>
          
            <div >
              <label style={{ fontWeight: "bold", fontSize: "14px" }} className='form-label'>
                Description
              </label>
            
              <input
                className="form-control mb-4"
                type='text'
                name='paymode_name'
                placeholder='Enter Description'
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          
            <div className="d-flex justify-content-end">
              
              <Button variant="secondary"  onClick={handleReset}>
                Reset
              </Button>
              <Button variant="success" className="ms-2" type="submit">
                Update
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showDelete}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
      
        size="md" // Set size to large
        centered
      >
       <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>

        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Payment  
          <span style={{color:"red",textTransform:"uppercase"}}></span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
</Modal>
    {/* </div> */}
    </Layout>
    </>
)
};


export default PaymodeStatusMaster;